import img from '../../assets/images/common/2807971.jpg'

const companyProfiles = [
    {
        image: img,
        title: "Daman National Health Insurance Company - Company profile, Business Description, Corporate Strategy, SWOT Analysis and Competitive Intelligence Report",
        info: "The company profile of Daman National Health Insurance Company provides in depth-analysis of business description and corporate strategy. The profile also provides competitive SWOT analysis of the company in the business segments it is operating across the regions. The analysis will assist in understanding the competitive strength and strategies of the company to sustain and gain higher shares in the markets it is operating in.",
        publishDate: "August 2018 ",
        price: "$ 200",
        category: "Energy and Power",
        sector: "Utility",
    },
    {
        image: img,
        title: "Global Reservoir Analysis Market - Company Profile (Weatherford International Ltd., Schlumberger Limited DSM, Baker Hughes, Inc., Jiangxi East, Halliburton, and SGS SA.)and Competitive intelligence report 2017",
        info: "The key players operating in the market include Weatherford International Ltd., Schlumberger Limited DSM, Baker Hughes, Inc., Jiangxi East, Halliburton, and SGS SA.",
        publishDate: "July 2018",
        price: "$ 595",
        category: "Life Sciences",
        sector: "Diagnostics and Biotech",
    },
    {
        image: img,
        title: "Oil Storage Market - Company Profile (ZCL Composites, Belco Manufacturing Company, Containment Solutions, Sunoco Logistics, Oiltanking GmbH, Columbian Steel Tank, Poly Processing, Synalloy Corporation, L.F. Manufacturing, and Red Ewald, Inc.)and Competitive intelligence report 2017",
        info: "The key players profiled in the report are ZCL Composites, Belco Manufacturing Company, Containment Solutions, Sunoco Logistics, Oiltanking GmbH, Columbian Steel Tank, Poly Processing, Synalloy Corporation, L.F. Manufacturing, and Red Ewald, Inc.",
        publishDate: "June 2017",
        price: "$ 595",
        category: "Aerospace & Defense",
        sector: "Commercial Aviation",
    },
    {
        image: img,
        title: "Daman National Health Insurance Company - Company profile, Business Description, Corporate Strategy, SWOT Analysis and Competitive Intelligence Report",
        info: "The company profile of Daman National Health Insurance Company provides in depth-analysis of business description and corporate strategy. The profile also provides competitive SWOT analysis of the company in the business segments it is operating across the regions. The analysis will assist in understanding the competitive strength and strategies of the company to sustain and gain higher shares in the markets it is operating in.",
        publishDate: "August 2018 ",
        price: "$ 200",
        category: "BFSI",
        sector: "Financial Services",
    },
    {
        image: img,
        title: "Global Reservoir Analysis Market - Company Profile (Weatherford International Ltd., Schlumberger Limited DSM, Baker Hughes, Inc., Jiangxi East, Halliburton, and SGS SA.)and Competitive intelligence report 2017",
        info: "The key players operating in the market include Weatherford International Ltd., Schlumberger Limited DSM, Baker Hughes, Inc., Jiangxi East, Halliburton, and SGS SA.",
        publishDate: "July 2018",
        price: "$ 595",
        category: "Life Sciences",
        sector: "Therapeutics",
    },
    {
        image: img,
        title: "Oil Storage Market - Company Profile (ZCL Composites, Belco Manufacturing Company, Containment Solutions, Sunoco Logistics, Oiltanking GmbH, Columbian Steel Tank, Poly Processing, Synalloy Corporation, L.F. Manufacturing, and Red Ewald, Inc.)and Competitive intelligence report 2017",
        info: "The key players profiled in the report are ZCL Composites, Belco Manufacturing Company, Containment Solutions, Sunoco Logistics, Oiltanking GmbH, Columbian Steel Tank, Poly Processing, Synalloy Corporation, L.F. Manufacturing, and Red Ewald, Inc.",
        publishDate: "June 2017",
        price: "$ 595",
        category: "Aerospace & Defense",
        sector: "Homeland Security",
    },
    {
        image: img,
        title: "Daman National Health Insurance Company - Company profile, Business Description, Corporate Strategy, SWOT Analysis and Competitive Intelligence Report",
        info: "The company profile of Daman National Health Insurance Company provides in depth-analysis of business description and corporate strategy. The profile also provides competitive SWOT analysis of the company in the business segments it is operating across the regions. The analysis will assist in understanding the competitive strength and strategies of the company to sustain and gain higher shares in the markets it is operating in.",
        publishDate: "August 2018 ",
        price: "$ 200",
        category: "BFSI",
        sector: "Banking",
    },
    {
        image: img,
        title: "Global Reservoir Analysis Market - Company Profile (Weatherford International Ltd., Schlumberger Limited DSM, Baker Hughes, Inc., Jiangxi East, Halliburton, and SGS SA.)and Competitive intelligence report 2017",
        info: "The key players operating in the market include Weatherford International Ltd., Schlumberger Limited DSM, Baker Hughes, Inc., Jiangxi East, Halliburton, and SGS SA.",
        publishDate: "July 2018",
        price: "$ 595",
        category: "Life Sciences",
        sector: "Pharmaceuticals",
    },
    {
        image: img,
        title: "Oil Storage Market - Company Profile (ZCL Composites, Belco Manufacturing Company, Containment Solutions, Sunoco Logistics, Oiltanking GmbH, Columbian Steel Tank, Poly Processing, Synalloy Corporation, L.F. Manufacturing, and Red Ewald, Inc.)and Competitive intelligence report 2017",
        info: "The key players profiled in the report are ZCL Composites, Belco Manufacturing Company, Containment Solutions, Sunoco Logistics, Oiltanking GmbH, Columbian Steel Tank, Poly Processing, Synalloy Corporation, L.F. Manufacturing, and Red Ewald, Inc.",
        publishDate: "June 2017",
        price: "$ 595",
        category: "Aerospace & Defense",
        sector: "Space",
    },
    {
        image: img,
        title: "Daman National Health Insurance Company - Company profile, Business Description, Corporate Strategy, SWOT Analysis and Competitive Intelligence Report",
        info: "The company profile of Daman National Health Insurance Company provides in depth-analysis of business description and corporate strategy. The profile also provides competitive SWOT analysis of the company in the business segments it is operating across the regions. The analysis will assist in understanding the competitive strength and strategies of the company to sustain and gain higher shares in the markets it is operating in.",
        publishDate: "August 2018 ",
        price: "$ 200",
        category: "BFSI",
        sector: "Insurance",
    },
    {
        image: img,
        title: "Global Reservoir Analysis Market - Company Profile (Weatherford International Ltd., Schlumberger Limited DSM, Baker Hughes, Inc., Jiangxi East, Halliburton, and SGS SA.)and Competitive intelligence report 2017",
        info: "The key players operating in the market include Weatherford International Ltd., Schlumberger Limited DSM, Baker Hughes, Inc., Jiangxi East, Halliburton, and SGS SA.",
        publishDate: "July 2018",
        price: "$ 595",
        category: "Life Sciences",
        sector: "Healthcare",
    },
    {
        image: img,
        title: "Oil Storage Market - Company Profile (ZCL Composites, Belco Manufacturing Company, Containment Solutions, Sunoco Logistics, Oiltanking GmbH, Columbian Steel Tank, Poly Processing, Synalloy Corporation, L.F. Manufacturing, and Red Ewald, Inc.)and Competitive intelligence report 2017",
        info: "The key players profiled in the report are ZCL Composites, Belco Manufacturing Company, Containment Solutions, Sunoco Logistics, Oiltanking GmbH, Columbian Steel Tank, Poly Processing, Synalloy Corporation, L.F. Manufacturing, and Red Ewald, Inc.",
        publishDate: "June 2017",
        price: "$ 595",
        category: "Aerospace & Defense",
        sector: "Defence",
    },
]


export default companyProfiles